const translationLabels = {
  // error pages messages
  'error_page.server_error.message': 'Something went wrong.<br /> Please check your internet connection or try again later.',
  'error_page.server_error.go_back_button': 'Go to the main page',
  'error_page.not_found.message': 'The page you\'re looking for does not exist.',
  'error_page.not_found.go_back_button': 'Go back',
  'error_page.not_found.go_to_main_page_button': 'Go to the main page',
  // Components
  'header.logo': 'Rewards',
  'label.drops_premium': 'REWARDS PREMIUM',
  'new_drop_card.button': 'Subscribe',
  'navigation_panel.gallery_tab': 'Rewards gallery',
  'navigation_panel.inventory_tab': 'Inventory',
  'login_button.logout': 'Log out',
  'item_card.instruction.title': 'How to Redeem',
  'item_card.claimed_status.promocode': 'Collected',
  'item_card.claimed_status.digital_item': 'Minted',
  'item_card.claim_button.digital_item.claiming': 'Claiming...',
  'item_card.claim_button.digital_item.default': 'Mint in backpack',
  'item_card.claim_button.promocode.claiming': 'Loading...',
  'item_card.claim_button.promocode.default': 'Collect',
  'item_card.claim_button.promocode.expired': 'Expired',
  'item_card.claim_button.promocode.fallback_message': 'Copied',
  'footer.rights_text': 'All rights reserved, {currentYear}. This site uses cookies.',
  'footer.privacy_policy': 'View our <a>privacy policy.</a>',
  'footer.cookie_settings': 'View <button>cookie settings.</button>',
  'drop_list.name': 'Available for free',
  'drop_list.name-alternative': 'Rewards',
  'drop_list.empty_message': 'You don\'t have any rewards yet. Check out the <a>gallery</a>, we\'re sure you\'ll find something to your liking.',
  'drop_card.collected_label': 'Collected',
  'drop_card.claim_button': 'Claim now',
  'gallery_list.title': 'Collections',
  'gallery_list.empty_message': 'You don\'t have any collections yet. Check out the <a>gallery</a>, we\'re sure you\'ll find something to your liking.',
  'collection_card.premium_label': 'Rewards premium',
  'collection_card.activate_subscription': 'Subscribe',
  'collection_card.open_collection_button': 'Open Collection',
  'collection_card.explore_collection_button': 'Explore Collection',
  'claim_drop_modal.subtitle': 'Congratulations!',
  'claim_drop_modal.title': '{dropName} is yours!',
  'claim_drop_modal.description': 'You can now redeem your code and use it for discount.',
  'claim_drop_modal.open_drop_button': 'Open reward',
  'claim_drop_modal.go_to_inventory_button': 'Go to inventory',
  // Main pages
  'gallery.banner.subtitle': 'What are rewards?',
  'gallery.banner.title': 'Game-changing reward programs',
  'gallery.banner.description': 'Unlock exclusive in-game items, currency packs, digital goodies, and many more rewards — all for free!',
  'collection_detail.drops_list.title': 'REWARDS IN THIS COLLECTIONS',
  'collection_detail.subscription_info_block.name': 'REWARDS PREMIUM SUBSCRIPTION',
  'collection_detail.subscription_info_block.title': 'EXCLUSIVE REWARDS <br /> EVERY MONTH',
  'collection_detail.subscription_info_block.description': 'Once signing up, you\'ll receive monthly reward which may include pack of random items: game keys, digital items and more surprises from some of the biggest names in gaming. As a bonus you also may get some delicious discounts.',
  'collection_detail.subscription_info_block.price': '$4.99<span> / month</span>',
  'collection_detail.subscription_info_block.button': 'Subscribe to Collection',
  'collection_detail.subscription_info_block.info': 'Subscription will renew automatically every month. You may cancel it in subscription section or by contacting support.',
  'collection_detail.subscription_info_block.terms': 'Terms & Conditions | Xsolla EULA',
  'reward_detail.read-more-button.text': 'Read More...',
  'reward_detail.read-more-button.alternative-text': 'Hide',
  'reward_detail.find-out-more-link.text': 'Find out more about this reward',
};

module.exports = translationLabels;
